export enum TableDisplayMode {
  list = 'list',
  grid = 'grid',
}
